import { AntDesign } from '@expo/vector-icons';
import { FirebaseAuthTypes, signOut as signOutMobile } from '@react-native-firebase/auth';
import { router } from 'expo-router';
import { Auth, signOut as signOutWeb } from 'firebase/auth';
import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Text from '@/components/Text';
import { useAuth } from '@/contexts/authContext';
import { useBottomSheet } from '@/contexts/bottomSheetContext';
import { useMeFavorites } from '@/contexts/favoritesContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { auth } from '@/firebaseConfig';
import { i18n } from '@/utils/i18n';

import BrandedButton from '../buttons/BrandedButton';
import CloseButton from '../buttons/CloseButton';
import { useDeepLinkStore } from '@/deepLinks/deepLinkStore';

const LogOutBottomSheet = () => {
  const { dispatch, clearCurrentUser } = useAuth();
  const { clearFavorites } = useMeFavorites();
  const { clearPendingLink } = useDeepLinkStore()
  const { resetCompleted } = useNpoLoginScreenState();
  const { dispatch: manageSheet } = useBottomSheet();

  //Locales
  const message = i18n.t('settings.logout.title');
  const log_out = i18n.t('settings.screen_names.logout');

  const onPressLogout = async () => {
    dispatch({ type: 'SIGN_OUT' });
    clearCurrentUser();
    if (Platform.OS === 'web') {
      await signOutWeb(auth() as Auth);
    } else {
      await signOutMobile(auth() as FirebaseAuthTypes.Module);
    }
    clearFavorites();
    clearPendingLink();
    resetCompleted();
    manageSheet({ type: 'SET_VISIBLE', setVisible: false });
    router.dismissAll();
    router.navigate('/(app)');
  };

  const onCloseTap = () => {
    manageSheet({ type: 'SET_VISIBLE', setVisible: false });
  };

  return (
    <SafeAreaView style={styles.flexOne} edges={['bottom']}>
      <View style={styles.container}>
        <CloseButton style={styles.closeBtn} onCloseTap={onCloseTap} />

        <Text style={styles.messageText} fontWeight="500">
          {message}
        </Text>
        <View style={styles.logOutCircle}>
          <AntDesign name="logout" size={35} color="black" />
        </View>
        <BrandedButton style={styles.logOutBtn} onPress={onPressLogout}>
          {log_out}
        </BrandedButton>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  container: {
    backgroundColor: 'white',
    paddingHorizontal: 18,
    flexDirection: 'column',
    alignItems: 'center'
  },

  closeBtn: {
    alignSelf: 'flex-start'
  },

  messageText: {
    marginTop: 16,
    color: 'black',
    fontSize: 18
  },

  logOutCircle: {
    backgroundColor: 'white',
    height: 100,
    width: 100,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },

    shadowOpacity: 0.12,
    shadowRadius: 10,
    elevation: 5,
    marginTop: 25,
    justifyContent: 'center',
    alignItems: 'center'
  },

  logOutBtn: {
    paddingHorizontal: 20,
    marginTop: 40,
    width: '100%'
  }
});

export default LogOutBottomSheet;
